import React, { useState } from 'react';
import BasicInput from '../Basic/BasicInput';

function BalastBonus({ balastBonus, countIndex, changeFieldsMultiple }) {
    const [stateBonus, setStateBonus] = useState(balastBonus);
    
    const changeBalastBonus = () => {
        balastBonus !== stateBonus && changeFieldsMultiple([
            {
                index: countIndex,
                field: 'balastBonus',
                value: stateBonus,
            },
        ]);
    };
    
    return (
        <BasicInput 
            name='balastBonus'
            value={stateBonus}
            onChange={e => setStateBonus(e.target.value)}
            floatingLabelStyle={{ display: 'none' }}
            underlineStyle={{ display: 'none' }}
            style={{ fontSize: '9px' }}
            type='number'
            onBlur={changeBalastBonus}
        />
    );
}

export default React.memo(BalastBonus);



// WEBPACK FOOTER //
// ./app/components/TcIndex/RowData/BalastBonus.jsx